module.exports = __webpack_public_path__ + "img/logo.81b3dab4.png";